"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CameraFilledIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M2 6.99C2 5.89 2.9 5 3.99 5h16.02c1.1 0 1.99.9 1.99 1.99V19a2 2 0 0 1-1.99 2H3.99C2.89 21 2 20.11 2 19.01zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-8c0 .56.45 1 1 1 .56 0 1-.45 1-1 0-.56-.45-1-1-1-.56 0-1 .45-1 1M8 4c0-.55.45-1 1-1h6.01c.55 0 1 .44 1 1v1H8z"/><circle cx="12" cy="13" r="2"/></g></svg>`
}, props));
CameraFilledIcon.displayName = 'CameraFilledIcon';
var _default = exports.default = CameraFilledIcon;